import React from 'react'
import Icon1 from '../../../images/lp/icon1.png'
import Icon2 from '../../../images/lp/icon2.png'
import Icon3 from '../../../images/lp/icon3.png'
import '../../../styles/Object/about_consultation.scss'

export const AboutConsultation: React.FC = () => {
  return (
    <div className="about-consultation">
      <div className="about-consultation__inner">
        <h3>認知症医療相談（無料）とは</h3>
        <p>
          認知症医療相談とは、認知症の症状に不安を抱える方々が、専門医を中心とした医療従事者に対して、パソコンやスマートフォンなどのオンライン上で、無料で手軽に、直接個別に相談や質問ができるサービスです。
        </p>
      </div>
      <div className="about-consultation__flexbox">
        <div className="about-consultation__flexbox-cell">
          <div className="about-consultation__flexbox-img">
            <img className="max-w-1/2" src={Icon1} />
          </div>
          <p>気軽にチャットで相談</p>
        </div>
        <div className="about-consultation__flexbox-cell">
          <div className="about-consultation__flexbox-img">
            <img className="max-w-1/2" src={Icon2} />
          </div>
          <p>
            医師を中心とした
            <br />
            医療チームが対応
          </p>
        </div>
        <div className="about-consultation__flexbox-cell">
          <div className="about-consultation__flexbox-img">
            <img className="max-w-1/2" src={Icon3} />
          </div>
          <p>いつも何度でも</p>
        </div>
      </div>
    </div>
  )
}
